export default __webpack_public_path__ + "static/media/delete.fec960ca.svg";